<template>
  <div class="header">
    <!-- pc端导航 -->
    <template v-if="isPc">
      <div class="header-main">
        <div class="logo-nav-area">
          <div class="logo-area">
<!--            <div class="logo-img">-->
<!--              <img src="@/assets/imgs/logo.png" alt="" />-->
<!--            </div>-->
            <h1 class="title" style="margin-left: 20px;">山东省二级建造师继续教育平台</h1>
          </div>
          <!-- 导航栏 -->
          <div class="nav-area">
            <el-menu
              :default-active="$route.path"
              class="el-menu-demo"
              mode="horizontal"
              background-color="#558ad6"
              text-color="#fff"
              active-text-color="#ffd04b"
              @select="handleSelect"
            >
              <el-menu-item index="/">首页</el-menu-item>
              <el-menu-item index="/mySubject">我的课程</el-menu-item>
              <el-menu-item index="/noticeList">通知公告</el-menu-item>
<!--              <el-menu-item index="/learningProcess">学习流程</el-menu-item>-->
<!--              <el-menu-item index="/attention">注意事项</el-menu-item>-->
<!--              <el-menu-item index="/problem">常见问题说明</el-menu-item>-->
              <el-menu-item index="/profile">个人中心</el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="func-area">
          <template v-if="!isLOgin">
            <div class="login" @click="goLogin">登录</div>
            <div class="register" @click="goRegister">注册</div>
          </template>
          <div v-else class="user-info-area">
            <el-avatar
              size="medium"
              :src="circleUrl"
              class="user-avatar"
            ></el-avatar>
            <div class="avatar-drop">
              <div class="avatar-name">
                <el-avatar
                  size="small"
                  :src="circleUrl"
                  style="margin-right: 20px"
                ></el-avatar>
                <span>{{ realName }}</span>
              </div>
              <div class="avatar-drop-list">
                <div class="avatar-drop-item" @click="goProfile">
                  <i class="el-icon-user"></i>
                  <span class="avatar-drop-item-text">个人中心</span>
                </div>
                <div class="avatar-drop-item" @click="goLogout">
                  <i class="el-icon-news"></i>
                  <span class="avatar-drop-item-text">退出登录</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 移动端导航头 -->
    <template v-else>
      <nav class="navbar bg-body-tertiary fixed-top">
        <div class="container-fluid">
          <div class="navbar-brand" href="#">山东省二级建造师继续教育平台</div>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              class="bi"
              fill="#fff"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              ></path>
            </svg>
          </button>
          <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasNavbarLabel">
                山东省二级建造师继续教育平台
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                <li class="nav-item">
                  <RouterLink class="nav-link active" aria-current="page" to="/"
                    >首页</RouterLink
                  >
                </li>
                <li class="nav-item dropdown">
                  <RouterLink
                    class="nav-link dropdown-toggle"
                    to="/mySubject"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    我的课程
                  </RouterLink>
                  <ul class="dropdown-menu">
                    <li>
                      <RouterLink class="dropdown-item" to="/mySubject"
                        >我的课程</RouterLink
                      >
                    </li>
                    <li>
                      <RouterLink class="dropdown-item" to="/myOptional"
                        >我的自选</RouterLink
                      >
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <RouterLink class="nav-link" to="/learningProcess"
                    >学习流程</RouterLink
                  >
                </li>
                <li class="nav-item">
                  <RouterLink class="nav-link" to="/attention"
                    >注意事项</RouterLink
                  >
                </li>
                <li class="nav-item">
                  <RouterLink class="nav-link" to="/problem"
                    >常见问题说明</RouterLink
                  >
                </li>
                <li class="nav-item">
                  <RouterLink class="nav-link" to="/profile"
                    >个人中心</RouterLink
                  >
                </li>
                <template v-if="!isLOgin">
                  <li class="nav-item">
                    <RouterLink class="nav-link" to="/logn">登录</RouterLink>
                  </li>
                  <li class="nav-item">
                    <RouterLink class="nav-link" to="/register"
                      >注册</RouterLink
                    >
                  </li>
                </template>
                <template v-else>
                  <li class="nav-item">
                    <div class="nav-link" @click="goLogout">退出登录</div>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </template>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "project-header",
  data() {
    return {
      search: "",
      isExpanded: false,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      surveyDialogVisible: false,
      evaluationDialogVisible: false,
      activeIndex: "home",
    };
  },
  created() {
    console.log(this.name);
  },
  computed: {
    isLOgin: function () {
      return getToken();
    },
    isPc: function () {
      var viewportWidth = window.innerWidth;
      return viewportWidth > 600;
    },
    ...mapGetters(["name", "realName"]),

  },
  methods: {
    toggleInput() {
      this.isExpanded = !this.isExpanded;
    },
    blurInput() {
      this.isExpanded = false;
    },
    goProfile() {
      let routeData = this.$router.resolve({
        name: "profile",
      });
      window.open(routeData.href, "_blank");
    },

    // 跳转登录页
    goLogin() {
      this.$router.push({ name: "Login" });
    },

    // 跳转注册页面
    goRegister() {
      let routeData = this.$router.resolve({
        name: "register",
      });
      window.open(routeData.href, "_blank");
    },

    async goLogout() {
      sessionStorage.removeItem('loginAnnouncementShown');
      localStorage.removeItem('loginAnnouncementShown');
      await this.$store.dispatch("user/logout");
      this.$message.success("退出成功");
    },
    // 导航条跳转
    handleSelect(key) {
      if (key === "/profile") {
        let routeData = this.$router.resolve({
          name: "profile",
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$router.push({ path: key });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
}
.el-menu-item {
  font-size: 16px;
}
.header-main {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 65px;
  padding: 0 10px;
  background-color: #fff;
  z-index: 1000;
  background: #558ad6;
}

.logo-nav-area {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}

.logo-area {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;

  .logo-img {
    width: 32px;
    height: 32px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  h1 {
    margin-left: 8px;
    font-size: 26px;
    color: #fff;
    letter-spacing: 2px;
    margin-bottom: 0px;
  }
}

.nav-area {
  margin-left: 50px;
  margin: 0 auto;
}

.nav-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;

  .nav-item {
    position: relative;
    padding: 0 10px;
    height: 100%;
    line-height: 65px;
    cursor: pointer;
    transition: all 0.3s;

    .custom-icon {
      font-size: 15px;
    }

    .nav-sub-list {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      opacity: 0;
      border-radius: 5px;
      overflow: hidden;
      transition: all 0.3s;
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);

      .nav-sub-item {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        font-size: 14px;
      }

      .nav-sub-item:hover a {
        color: #558ad6;
      }
    }
  }

  .active {
    position: relative;
    color: #558ad6;
    font-weight: 500;
  }

  .active::after {
    content: "";
    position: absolute;
    bottom: 13%;
    left: 50%;
    width: 40%;
    height: 2px;
    background-color: #558ad6;
    transform: translateX(-50%);
  }

  .nav-item:hover > a {
    color: #558ad6;
  }

  .nav-item:hover .nav-sub-list {
    display: block;
    opacity: 1;
  }
}

.func-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: 100px;
  margin-right: 30px;
  .search-area {
    .search-area-input {
      display: flex;
      align-items: center;

      .search-icon-custom {
        font-weight: 700;
        color: #555;
        cursor: pointer;
      }

      ::v-deep .input-with-select .el-input__inner {
        width: 0;
        border-radius: 20px;
        border: 1px solid transparent;
        background-color: #f3f5f7;
        transition: all 0.5s;
      }

      ::v-deep .input-with-select {
        cursor: pointer;
      }

      ::v-deep .input-with-select .el-input__inner:focus {
        border: 1px solid #558ad6;
        background-color: #fff;
      }
    }

    ::v-deep .expanded {
      .input-with-select .el-input__inner {
        width: 140px;
      }
    }
  }

  .bell-custom-icon {
    margin: 0 18px;
    font-weight: 700;
    color: #555;
    cursor: pointer;
  }

  .sort-custom-icon {
    margin-right: 4px;
    transform: rotate(90deg);
  }

  .user-info-area {
    height: 100%;
    padding: 0 15px;
    margin: 0 0 0 0 ;
    display: flex;
    align-items: center;
    position: relative;

    .user-avatar {
      cursor: pointer;
    }

    .avatar-drop {
      display: none;
      position: absolute;
      right: -20px;
      top: 100%;
      overflow: hidden;
      width: 160px;
      height: 314px;
      border-radius: 10px;
      background-color: #fff;
      cursor: pointer;
      box-shadow: 0 0 10px 2px #e4e9f4;

      .avatar-name {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        padding: 20px;
        font-size: 16px;
        background: linear-gradient(90deg, #edf2fa, #e4e9f4);
      }

      .avatar-drop-list {
        padding: 5px 10px;

        .avatar-drop-item {
          padding: 14px 0;
          font-size: 14px;
          text-align: center;
          color: #444;
          border-radius: 6px;

          .avatar-drop-item-text {
            margin: 0 6px;
          }
        }

        .avatar-drop-item:hover {
          background-color: #f7e6e0;
        }
      }
    }

    .user-info-area::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 1px;
      height: 50%;
      background-color: #e6e8ea;
      transform: translateY(-50%);
    }
  }

  .user-info-area:hover .avatar-drop {
    display: block;
  }
}

.evaluation-content {
  text-align: center;
  padding: 50px 0;
}

.empty-icon {
  width: 64px;
  height: 64px;
}

.empty-text {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
  background: #558ad6;
}

.login {
  font-size: 14px;
  margin-right: 10px;
}
.login,
.register {
  font-size: 14px;
  cursor: pointer;
  color: #FFFFFF;
}
</style>
